import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
    const token = localStorage.getItem("sf_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const authAPI = {
    register: (data) => http.post("/auth/register", data).then((r) => r.data),
    login: (data) => http.post("/auth/login", data).then((r) => r.data),
    me: () => http.get("/auth/me").then((r) => r.data),
};

export const referralAPI = {
    me: () => http.get("/referral/me").then((r) => r.data),
};

export const adminAPI = {
    leads: (q = "") => http.get("/admin/leads", { params: { q } }).then((r) => r.data),
    stats: () => http.get("/admin/stats").then((r) => r.data),
};

export const studioAPI = {
    quiz: (data) => http.post("/quiz/concept", data).then((r) => r.data),
    episode: (data) => http.post("/episode/generate", data).then((r) => r.data),
    character: (data) => http.post("/character/generate", data).then((r) => r.data),
    characterImage: (data) => http.post("/character/image", data).then((r) => r.data),
    viral: (data) => http.post("/viral/analyze", data).then((r) => r.data),
    monetization: (data) => http.post("/monetization/roadmap", data).then((r) => r.data),
    calendar: (data) => http.post("/calendar/30days", data).then((r) => r.data),
    library: () => http.get("/library").then((r) => r.data),
    trends: (lang) => http.get(`/trends/weekly?lang=${lang}`).then((r) => r.data),
    exportEpisodeUrl: (episodeId) => `${API}/export/episode/${episodeId}`,
    sourceFetch: (url) => http.post("/source/youtube/fetch", { url }).then((r) => r.data),
    sourceShort: (data) => http.post("/source/youtube/short", data).then((r) => r.data),
};

export const paymentsAPI = {
    checkout: (plan, units = 1) => http.post("/payments/checkout", { plan, units, origin_url: window.location.origin }).then((r) => r.data),
    portal: () => http.post("/payments/portal", { origin_url: window.location.origin }).then((r) => r.data),
    status: (sessionId) => http.get(`/payments/status/${sessionId}`).then((r) => r.data),
};

export const quotaAPI = {
    me: () => http.get("/quota/me").then((r) => r.data),
    history: (days = 30) => http.get(`/quota/history?days=${days}`).then((r) => r.data),
};

export const projectsAPI = {
    list: () => http.get("/projects").then((r) => r.data),
    create: (data) => http.post("/projects", data).then((r) => r.data),
    update: (id, data) => http.patch(`/projects/${id}`, data).then((r) => r.data),
    remove: (id) => http.delete(`/projects/${id}`).then((r) => r.data),
    allocate: (allocations) => http.post("/projects/allocate", { allocations }).then((r) => r.data),
};

export const directorAPI = {
    chat: (message, project_id, language) => http.post("/director/chat", { message, project_id, language }).then((r) => r.data),
    history: (project_id) => http.get(`/director/history${project_id ? `?project_id=${project_id}` : ""}`).then((r) => r.data),
    clear: (project_id) => http.delete(`/director/history${project_id ? `?project_id=${project_id}` : ""}`).then((r) => r.data),
};

export const tryParseJSON = (raw) => {
    if (!raw) return null;
    try {
        const cleaned = raw
            .replace(/^```json\s*/i, "")
            .replace(/^```\s*/i, "")
            .replace(/\s*```\s*$/i, "")
            .trim();
        return JSON.parse(cleaned);
    } catch {
        const match = raw.match(/\{[\s\S]*\}/);
        if (match) { try { return JSON.parse(match[0]); } catch { return null; } }
        return null;
    }
};
